import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
import Vr from '../views/Vr.vue'
import Rhythm from '../views/Rhythm.vue'
import Tropa from '../views/Tropa.vue'
import Chudo from '../views/Chudo.vue'
import Result from '../views/Result.vue'

Vue.use(VueRouter)
  
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/vr',
    name: 'Vr',
    component: Vr
  },
  {
    path: '/rhythm',
    name: 'Rhythm',
    component: Rhythm
  },
  {
    path: '/tropa',
    name: 'Tropa',
    component: Tropa
  },
  {
    path: '/chudo',
    name: 'Chudo',
    component: Chudo
  },
  {
    path: '/result',
    name: 'Result',
    component: Result
  },
]

const router = new VueRouter({
  mode: 'history',

  scrollBehavior () {
    setTimeout(() => {
      window.scrollTo(0,0);
    }, 400)
  },

  routes
})

router.beforeEach((to, from, next) => {
  if (from.name) {
    store.dispatch('changeAnim', true);
    setTimeout(() => {
      next()
    }, 1000)
    setTimeout(() => {
      store.dispatch('changeAnim', false);
    }, 2000)
  } else {
    next()
  }
})

export default router
